/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { ParagraphType } from '@ecsper/speciality-contract';

/**
 * Paragraph types contributed by the Expert Witness speciality.
 * Aligned with WKS Workspace PARAGRAPH_TYPE namespace
 * (ref_item entries: fact, opinion, analysis, methodology, conclusion).
 */
export const expertWitnessParagraphTypes: readonly ParagraphType[] = [
  {
    id: 'fact',
    displayName: { 'en-GB': 'Fact' },
    colour: 'var(--color-brand-500)',
    description: { 'en-GB': "Statement of fact within the expert's knowledge" },
  },
  {
    id: 'opinion',
    displayName: { 'en-GB': 'Opinion' },
    colour: 'var(--color-warning-500)',
    description: { 'en-GB': 'Expert opinion attributed to the expert' },
  },
  {
    id: 'analysis',
    displayName: { 'en-GB': 'Analysis' },
    colour: 'var(--color-brand-primary)',
    description: { 'en-GB': 'Analytical reasoning linking facts to opinions' },
  },
  {
    id: 'methodology',
    displayName: { 'en-GB': 'Methodology' },
    colour: 'var(--color-success-500)',
    description: { 'en-GB': 'Methodological approach and assumptions' },
  },
  {
    id: 'conclusion',
    displayName: { 'en-GB': 'Conclusion' },
    colour: 'var(--color-danger-500)',
    description: { 'en-GB': 'Concluding finding or recommendation' },
  },
] as const;
